import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { Card } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useOnboardingAnalytics } from '@/hooks/useAnalytics';
import { getAnalyticsAnchor, getOnboardingPresetRange } from '@/utils/onboardingPeriod';
import { formatTime, integer } from './analytics/AnalyticsPrimitives';
import './DashboardAnalytics.css';

export function DashboardAnalytics({ through }: { through: string }) {
  const range = getOnboardingPresetRange('MONTH', getAnalyticsAnchor(new Date(through)));
  const query = useOnboardingAnalytics(range);
  const previousThrough = useRef(through);
  const { refetch } = query;
  useEffect(() => {
    const previous = previousThrough.current;
    previousThrough.current = through;
    // A new bucket already fetches through the query key; within the same bucket the refresh button must retry.
    if (previous !== through && getAnalyticsAnchor(new Date(previous)) === range.to) void refetch();
  }, [through, range.to, refetch]);
  const data = query.isError ? undefined : query.data;
  const snapshot = data?.onboarding;
  const milestones = [
    { label: 'Neue Accounts', scope: 'Angelegt in den letzten 30 Tagen', count: snapshot?.cohortSize },
    {
      label: 'Verrechnungs- & Kryptokonto eingerichtet',
      scope: 'Letzte 30 Tage · unabhängig vom Registrierungsdatum',
      count: data?.period.tradevestCompleted,
    },
    {
      label: 'Depots für Aktien & ETFs',
      scope: 'Aktuell verfügbar · Gesamtbestand',
      count: data?.totals.securitiesDepotsAvailable,
    },
  ];
  return (
    <Card
      className="dashboard-analytics"
      title={
        <div className="dashboard-analytics-heading">
          Onboarding
          {data && <small>Stand {formatTime(data.measuredAt)} (Berlin)</small>}
        </div>
      }
      extra={
        <Link to="/analytics?tab=onboarding">
          Analyse öffnen <ArrowRightOutlined />
        </Link>
      }
    >
      {snapshot ? (
        <div className="dashboard-analytics-milestones">
          {milestones.map(item => (
            <div key={item.label}>
              <span>{item.label}</span>
              <strong>{item.count == null ? '—' : integer.format(item.count)}</strong>
              <span>{item.scope}</span>
            </div>
          ))}
        </div>
      ) : (
        <p>{query.isPending ? 'Onboarding wird geladen …' : 'Onboarding konnte nicht geladen werden.'}</p>
      )}
    </Card>
  );
}
